import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const updateUtilityAPI = async (
  fwId,
  utilityIds,
  companyIds,
  modelIds,
  note,
  t,
  successfulText
) => {
  await axios({
    url: `/api/v2/admin-utility/utility/update`,
    method: "PUT",
    data: {
      id: fwId,
      note: note,
      company_ids: companyIds,
      device_model_ids: modelIds,
      firmware_ids: utilityIds
    }
  });
  successHandling(t, successfulText);
  return true;
};
